<template>
    <div class="my-page">
        <!-- 用户信息区域 -->
        <div class="user-section">
            <div class="user-info">
                <div class="profile-pic">
                    <div class="profile-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 2L13.09 8.26L20 9L13.09 9.74L12 16L10.91 9.74L4 9L10.91 8.26L12 2Z"
                                fill="currentColor" />
                        </svg>
                    </div>
                </div>
                <div class="user-details">
                    <div class="form-group">
                        <span class="form-group-label">推广名：</span>
                        <span style="font-size: 14px;">{{ userName }}</span>
                    </div>
                    <div class="form-group">
                        <span class="form-group-label">推广ID：</span>
                        <span style="font-size: 14px;">{{ userId }}</span>
                        <button class="copy-btn" @click="copyUserId">复制</button>
                    </div>
                    <!-- <div class="form-group">
                        <label>邀请码:</label>
                        <span>{{ inviteCode }}</span>
                        <button class="copy-btn" @click="copyInviteCode">复制</button>
                    </div> -->
                </div>
            </div>
        </div>

        <!-- 结算信息区域 -->
        <!-- <div class="settlement-section">
            <div class="settlement-content">
                <div class="settlement-text">结算信息</div>
                <button class="view-btn" @click="viewSettlement">查看</button>
            </div>
        </div> -->

        <!-- 小店管理区域 -->
        <div class="shop-management-section">
            <!-- <div style="font-size: 18px;font-weight: bold;margin-bottom: 8px;">小店管理</div> -->
            <div class="features-grid">
                <!-- <div class="feature-item" @click="handleFeature('invite-promotion')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M22 6L12 13L2 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">邀请推广</div>
                </div> -->

                <div class="feature-item" @click="handleFeature('settlement-management')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8 9H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M8 13H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">结算信息</div>
                </div>

                <div class="feature-item" @click="handleFeature('my-invitations')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M8 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">我的邀请</div>
                </div>

                <!-- <div class="feature-item" @click="handleFeature('invite-earn')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8 9H16" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M8 13H12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">邀新赚钱</div>
                </div> -->

                <div class="feature-item" @click="handleFeature('real-name-verification')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16 4H18C19.1046 4 20 4.89543 20 6V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V6C4 4.89543 4.89543 4 6 4H8"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M8 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16 2V6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">实名信息</div>
                </div>

                <div class="feature-item" @click="handleFeature('contact-us')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7293C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1468 21.5901 20.9046 21.7335 20.6407 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77382 17.3147 6.72533 15.2662 5.18999 12.85C3.49997 10.2412 2.44824 7.27099 2.11999 4.18C2.095 3.90347 2.12787 3.62476 2.21649 3.36162C2.30512 3.09849 2.44756 2.85669 2.63476 2.65162C2.82196 2.44655 3.0498 2.28271 3.30379 2.17052C3.55777 2.05833 3.83233 2.00026 4.10999 2H7.10999C7.59531 1.99522 8.06679 2.16708 8.43376 2.48353C8.80073 2.79999 9.04207 3.23945 9.11999 3.72C9.23662 4.68007 9.47144 5.62273 9.81999 6.53C9.94454 6.88792 9.97366 7.27691 9.90491 7.65088C9.83615 8.02485 9.67181 8.36811 9.42999 8.65L8.08999 10.12C9.51355 12.1675 11.346 13.9999 13.39 15.42L14.86 14.08C15.1443 13.8422 15.4897 13.6813 15.8641 13.6129C16.2385 13.5445 16.6271 13.5713 16.99 13.69C17.8973 14.0386 18.8399 14.2734 19.8 14.39C20.2816 14.4679 20.722 14.7092 21.0385 15.0762C21.3549 15.4432 21.5268 15.9147 21.52 16.4L22 16.92Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">联系我们</div>
                </div>

                <div class="feature-item" @click="handleFeature('promotion-guidelines')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M14 2V8H20" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16 13H8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M16 17H8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M10 9H8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">推广规范</div>
                </div>

                <div class="feature-item" @click="handleFeature('customer-acquisition-guide')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M4 19.5C4 18.837 4.26339 18.2011 4.73223 17.7322C5.20107 17.2634 5.83696 17 6.5 17H20"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path
                                d="M6.5 2H20V22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.7989 4 20.163 4 19.5V4.5C4 3.83696 4.26339 3.20107 4.73223 2.73223C5.20107 2.26339 5.83696 2 6.5 2Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M8 12L12 16L16 8" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <circle cx="16" cy="8" r="2" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">获客指南</div>
                </div>

                <!-- 管理员功能 -->
                <div v-if="isAdmin" class="feature-item" @click="handleFeature('site-management')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3 9L12 2L21 9V20C21 20.5304 20.7893 21.0391 20.4142 21.4142C20.0391 21.7893 19.5304 22 19 22H5C4.46957 22 3.96086 21.7893 3.58579 21.4142C3.21071 21.0391 3 20.5304 3 20V9Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M9 22V12H15V22" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">媒体管理</div>
                </div>

                <div v-if="isAdmin" class="feature-item" @click="handleFeature('position-management')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.27 6.96L12 12.01L20.73 6.96" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">推广管理</div>
                </div>

                <div v-if="isAdmin" class="feature-item" @click="handleFeature('guide-management')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.27 6.96L12 12.01L20.73 6.96" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">攻略管理</div>
                </div>

                <div v-if="isAdmin" class="feature-item" @click="handleFeature('product-management')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3 7H21M7 7V5C7 4.20435 7.31607 3.44129 7.87868 2.87868C8.44129 2.31607 9.20435 2 10 2H14C14.7956 2 15.5587 2.31607 16.1213 2.87868C16.6839 3.44129 17 4.20435 17 5V7M10 13V17M14 13V17M5 7H19L18 21H6L5 7Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">商品管理</div>
                </div>

                <div v-if="isAdmin" class="feature-item" @click="handleFeature('liberay-management')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.27 6.96L12 12.01L20.73 6.96" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">仓库管理</div>
                </div>

                <div v-if="isAdmin" class="feature-item" @click="handleFeature('enum-values')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M21 16V8C20.9996 7.64927 20.9071 7.30481 20.7315 7.00116C20.556 6.69751 20.3037 6.44536 20 6.27L13 2.27C12.696 2.09446 12.3511 2.00205 12 2.00205C11.6489 2.00205 11.304 2.09446 11 2.27L4 6.27C3.69626 6.44536 3.44398 6.69751 3.26846 7.00116C3.09294 7.30481 3.00036 7.64927 3 8V16C3.00036 16.3507 3.09294 16.6952 3.26846 16.9988C3.44398 17.3025 3.69626 17.5546 4 17.73L11 21.73C11.304 21.9055 11.6489 21.9979 12 21.9979C12.3511 21.9979 12.696 21.9055 13 21.73L20 17.73C20.3037 17.5546 20.556 17.3025 20.7315 16.9988C20.9071 16.6952 20.9996 16.3507 21 16Z"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M3.27 6.96L12 12.01L20.73 6.96" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M12 22.08V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">枚举管理</div>
                </div>

                <div class="feature-item" @click="handleFeature('order')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                                fill="currentColor" />
                            <path d="M10 9H18V11H10V9ZM10 13H18V15H10V13ZM10 17H15V19H10V17Z" fill="currentColor" />
                        </svg>
                    </div>
                    <div class="feature-label">自查地址</div>
                </div>

                <div class="feature-item" @click="handleFeature('logout')">
                    <div class="feature-icon">
                        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            <path d="M16 17L21 12L16 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                            <path d="M21 12H9" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </div>
                    <div class="feature-label">退出登录</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { copyToClipboardWithMessage } from '@/utils/clipboard'

export default {
    name: 'MyPage',
    data() {
        return {
            userName: '',
            userId: '',
            inviteCode: 'TK5A5',
            currentUser: null
        }
    },
    computed: {
        isAdmin() {
            return this.currentUser && this.currentUser.role === 'ADMIN'
        }
    },
    mounted() {
        // 从localStorage获取当前登录用户信息
        this.loadUserInfo()
    },
    methods: {
        // 加载用户信息
        loadUserInfo() {
            try {
                const userStr = localStorage.getItem('user')
                if (userStr) {
                    const user = JSON.parse(userStr)
                    this.currentUser = user
                    this.userName = user.positionName
                    this.userId = user.positionId || '未登录'
                } else {
                    this.userName = '未登录'
                    this.userId = '未登录'
                }
            } catch (error) {
                console.error('加载用户信息失败:', error)
                this.userName = '加载失败'
                this.userId = '加载失败'
            }
        },

        // 复制邀请码
        copyUserId() {
            copyToClipboardWithMessage(this.userId, this, '用户ID已复制到剪贴板', '复制失败，请手动复制')
        },
        copyInviteCode() {
            copyToClipboardWithMessage(this.inviteCode, this, '邀请码已复制到剪贴板', '复制失败，请手动复制')
        },

        // 查看结算信息
        viewSettlement() {
            this.$router.push('/mydetails')
        },


        // 处理功能点击
        handleFeature(feature) {
            // 根据功能类型执行不同操作
            switch (feature) {
                case 'invite-promotion':
                    // 跳转到邀请推广页面
                    break
                case 'my-invitations':
                    // 跳转到我的邀请页面
                    this.$router.push('/my-invites')
                    break
                case 'invite-earn':
                    // 跳转到邀新赚钱页面
                    break
                case 'real-name-verification':
                    // 跳转到实名认证页面
                    this.$router.push('/realname-verification')
                    break
                case 'contact-us':
                    // 跳转到联系我们页面
                    this.$router.push('/contact-us')
                    break
                case 'promotion-guidelines':
                    // 跳转到推广规范页面
                    this.$router.push('/promotion-guidelines')
                    break
                case 'customer-acquisition-guide':
                    // 跳转到获客指南页面
                    this.$router.push('/customer-acquisition-guide')
                    break
                case 'site-management':
                    // 跳转到媒体ID管理页面
                    this.$router.push('/site-management')
                    break
                case 'position-management':
                    // 跳转到推广位管理页面
                    this.$router.push('/position-management')
                    break
                case 'logout':
                    // 处理退出登录
                    this.handleLogout()
                    break
                case 'guide-management':
                    // 攻略管理
                    this.$router.push('/guide-management')
                    break
                case 'liberay-management':
                    // 仓库管理
                    this.$router.push('/liberay-management')
                    break
                case 'enum-values':
                    // 枚举管理
                    this.$router.push('/enum-values')
                    break
                case 'product-management':
                    this.$router.push('/product-management')
                    break
                case 'order':
                    // 点击复制查询订单地址
                    {
                        const positionId = JSON.parse(localStorage.getItem('user')).positionId || ''
                        const link = 'http://dongdong-union.top/order-group-query?d=' + positionId
                        // 使用公共的复制方法
                        copyToClipboardWithMessage(link, this, '链接已复制到剪贴板', '复制失败，请手动复制')
                    }
                    break
                case 'settlement-management':
                    // 结算管理
                    this.viewSettlement()
                    break
            }
        },

        // 处理退出登录
        handleLogout() {
            if (confirm('确定要退出登录吗？')) {
                // 清除所有登录信息
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                localStorage.removeItem('savedCredentials')
                // 跳转到登录页面
                this.$router.push('/login')
            }
        },

        // 处理账号切换
        handleSwitchAccount() {
            if (confirm('确定要切换账号吗？')) {
                // 执行登出逻辑
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                // 刷新页面回到登录状态
                window.location.reload()
            }
        },

        // 显示消息提示
        showMessage(message, type = 'info') {
            // 创建消息元素
            const messageEl = document.createElement('div')
            messageEl.className = `message-toast message-${type}`
            messageEl.textContent = message

            // 添加样式
            Object.assign(messageEl.style, {
                position: 'fixed',
                top: '20px',
                left: '50%',
                padding: '12px 24px',
                borderRadius: '6px',
                color: 'white',
                fontSize: '14px',
                zIndex: '9999',
                transition: 'all 0.3s ease',
                opacity: '0',
                transform: 'translateX(-50%) translateY(-20px)'
            })

            // 根据类型设置背景色
            const colors = {
                success: '#67c23a',
                error: '#f56c6c',
                warning: '#e6a23c',
                info: '#409eff'
            }
            messageEl.style.backgroundColor = colors[type] || colors.info

            // 添加到页面
            document.body.appendChild(messageEl)

            // 显示动画
            setTimeout(() => {
                messageEl.style.opacity = '1'
                messageEl.style.transform = 'translateX(-50%) translateY(0)'
            }, 10)

            // 3秒后移除
            setTimeout(() => {
                messageEl.style.opacity = '0'
                messageEl.style.transform = 'translateX(-50%) translateY(-20px)'
                setTimeout(() => {
                    if (messageEl.parentNode) {
                        messageEl.parentNode.removeChild(messageEl)
                    }
                }, 300)
            }, 3000)
        }
    }
}
</script>

<style scoped>
.my-page {
    padding: 20px;
    flex: 1;
    box-sizing: border-box;
    background: linear-gradient(#42b983 0%, rgba(66, 185, 131, 0.35) 50%, rgba(66, 185, 131, 0.15) 70%, #ffffff 100%);
}

.user-section,
.settlement-section,
.shop-management-section {
    margin-bottom: 10px;
    padding: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background: #f9f9f9;
}

.form-group {
    display: flex;
    align-items: center;
}

.form-group .form-group-label {
    font-weight: bold;
}

.form-group input,
.form-group select {
    width: 200px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    height: 36px;
    box-sizing: border-box;
    background-color: white;
    color: #333;
    font-size: 14px;
}

.user-info {
    display: flex;
    align-items: flex-start;
    gap: 20px;
}

.profile-pic {
    position: relative;
    flex-shrink: 0;
}

.profile-icon {
    width: 50px;
    height: 50px;
    background: #42b983;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 24px;
}

.refresh-icon {
    position: absolute;
    bottom: -5px;
    right: -5px;
    width: 20px;
    height: 20px;
    background: #ff7043;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 10px;
    border: 2px solid white;
}

.user-details {
    flex: 1;
    text-align: left;
}

.invite-code-input {
    display: flex;
    gap: 10px;
    align-items: center;
}

.invite-code-input input {
    flex: 1;
    max-width: 150px;
}

.copy-btn {
    background: #42b983;
    color: white;
    border: none;
    margin-left: 10px;
    padding: 0px 6px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    height: 20px;
    box-sizing: border-box;
}

.copy-btn:hover {
    background: #369870;
}

.settlement-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.settlement-text {
    font-size: 16px;
    color: #333;
    font-weight: 500;
}

.view-btn {
    background: #42b983;
    color: white;
    border: none;
    padding: 0px 6px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    height: 20px;
    box-sizing: border-box;
}

.view-btn:hover {
    background: #369870;
}

.features-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
}

.feature-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 4px 0px;
    border: 1px solid #ddd;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: white;
}

.feature-item:hover {
    border-color: #42b983;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.feature-icon {
    width: 48px;
    height: 48px;
    background: #42b983;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-bottom: 4px;
    transition: all 0.3s ease;
}

.feature-item:hover .feature-icon {
    background: #369870;
    transform: scale(1.1);
}

.feature-label {
    font-size: 14px;
    color: #333;
    text-align: center;
    font-weight: 500;
    line-height: 1.4;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .my-page {
        padding: 10px;
    }

    .user-section,
    .settlement-section,
    .shop-management-section {
        padding: 10px;
    }

    .form-group label {
        width: auto;
        display: block;
        margin-bottom: 6px;
    }

    .form-group input,
    .form-group select {
        width: 100%;
        box-sizing: border-box;
    }

    .user-info {
        align-items: center;
        text-align: center;
    }

    .invite-code-input {
        flex-direction: column;
        align-items: stretch;
    }

    .invite-code-input input {
        max-width: none;
    }

    .settlement-content {
        gap: 15px;
        align-items: stretch;
    }

    .features-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
    }

    .feature-item {
        padding: 4px 0px;
    }

    .feature-icon {
        width: 30px;
        height: 30px;
    }

    .feature-label {
        font-size: 13px;
    }
}

@media (max-width: 480px) {
    .features-grid {
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 12px;
    }
}
</style>